import store from "@/store";
import organizationService from "@/services/repositories/organizationRepository";
// import listener from "@/bin/aws/listener";
/**
 * @async
 * @description Checks to see if we already tried getting the organization.
 * @returns {Boolean}
 */
async function isInitialized() {
  console.log("Checking....");
  if (store.state.initialize === false) {
    return false;
  }
  return true;
}
/**
 * @async
 * @description Fetches the organization that this container will be replicated around.
 */
async function fetchOrganization() {
  try {
    console.log("Sending it");
    let organization = await organizationService.get();
    return organization;
  } catch (err) {
    console.log("Organization", err);
    return null;
  }
}
export default {
  isInitialized,
  fetchOrganization
};
